export default "/server-build/img/4e9bace1203e9874f58017361ed21d05.png";